uniform float uFadeTime;
attribute float size;
attribute float aAlpha;
varying float alpha;
varying vec3 vColor;

void main()
{
    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
    gl_PointSize = size * (800.0 / -mvPosition.z); // Correct perspective scale
    
    alpha = aAlpha * uFadeTime;
    vColor = color; // Built-in vertex color attribute or custom attribute (three.js maps attribute vec3 color automatically when vertexColors is true)
    
    gl_Position = projectionMatrix * mvPosition;
}